import styled, { css, keyframes } from 'styled-components'
import { COLOR } from '../../assets/constants/constants'


const BackgroundLoading = styled.div`
  background: ${COLOR.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

const Loading = styled.div`
  width: 100px;
  height: 100px;
  margin: 30px auto;
  position: relative;
`;

const OuterShadow = styled.div`
  z-index: 6;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  box-shadow: inset 0 1px 0 rgba(0, 0, 0, .2);
`;

const InnerShadow = styled.div`
  ${OuterShadow}
  top: 50%;
  left: 50%;
  width: 80px;
  height: 80px;
  margin-left: -40px;
  margin-top: -40px;
  border-radius: 100%;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
`;

const Timer = styled.div`
  ${OuterShadow}
  z-index: 1;
  box-shadow: none;
`;

const Hold = css`
  position: absolute;
  width: 100%;
  height: 100%;
  clip: rect(0px, 100px, 100px, 50px);
  border-radius: 100%;
  background-color: #fff;
`;

const PieDotSpan = css`
  background-color: ${COLOR.primary};
`;

const dotSpan = css`
  position: absolute;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: 100%;
`;

const dot = keyframes`
  0% { transform: rotate(-90deg); }
  50% { transform: rotate(90deg); z-index: 4; }
  100% { transform: rotate(270deg); z-index: 4; }
`;

const Dot = styled.div`
  ${PieDotSpan}
  z-index: 2;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 50%;
  height: 10px;
  margin-top: -5px;
  animation: ${dot} 8s linear both;
  transform-origin: 0% 50%;
  ${dotSpan}
`;

const StyledSpan = styled.span`
  ${PieDotSpan}
  z-index: 2;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 50%;
  height: 10px;
  margin-top: -5px;
  animation: dot 8s linear both;
  transform-origin: 0% 50%;
`;

const left = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(180deg); }
`;

const right = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(180deg); }
`;

const leftPie = css`
  z-index: 1;
  animation: ${left} 4s linear both;
`;

const rightPie = css`
  animation: ${right} 4s linear both;
  animation-delay: 4s;
`;

const Pie = styled.div`
  ${PieDotSpan}
  ${leftPie}
  ${rightPie}
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  clip: rect(0px, 50px, 100px, 0px);

`;

const HoldLeft = styled.div`
  ${Hold}
  ${leftPie}
`;

const HoldRight = styled.div`
  ${Hold}
  z-index: 3;
  transform: rotate(180deg);
`;

const StyledDiv = styled.div`
  height: 200px;
  width: 635px;
  text-align: center;
  color: #fff;
  font-family: 'Amorim Sans Book';
  position: absolute;

  @media (max-width: 600px) {
    width: 320px;
  }
`;

const IconDiv = styled.div`
  width: 60px;
  position: relative;
  top: ${p => p.mobile ? -117 : -165}px;
  left: ${p => p.mobile ? 130 : 287}px;
  z-index: 10;
`;

export { StyledDiv, Loading, IconDiv, OuterShadow, InnerShadow, Timer, Pie, Dot, StyledSpan, HoldLeft, HoldRight, BackgroundLoading }
